import React, {
  createContext,
  ReactNode,
  useContext,
  useEffect,
  useState,
} from 'react';

const IsArchonAppContext = createContext(false);

export const IsArchonAppProvider = ({
  initialValue = false,
  children,
}: {
  initialValue?: boolean;
  children: ReactNode;
}) => {
  const [isArchonApp, setIsArchonApp] = useState<boolean>(initialValue);

  useEffect(() => {
    if (
      typeof window !== 'undefined' &&
      window.navigator &&
      window.navigator.userAgent
    ) {
      if (window.navigator.userAgent.includes('ArchonApp')) {
        setIsArchonApp(true);
      }
    }
  }, []);

  return (
    <IsArchonAppContext.Provider value={isArchonApp}>
      {children}
    </IsArchonAppContext.Provider>
  );
};

export const useIsArchonApp = (): boolean => useContext(IsArchonAppContext);
